// An event moved to another environment answers check-event with 404 plus
// `moved_to_site` (the target environment's site origin). A guest who opened
// an old link is sent to the same path on that site.
//
// Returns the absolute URL to redirect to, or null when no redirect applies:
// field missing/not a string, not https, unparsable, or the same origin as the
// page (which would loop).
//
// One hop at most: the redirect adds MOVED_PARAM, and a page that already
// carries it never redirects again. An event moved A -> B -> A and then
// archived leaves a marker on both sites; without the guard they would bounce
// the guest between them forever.
export const MOVED_PARAM = "mm_moved";

export function movedEventRedirectUrl(errorData, location) {
  const site = errorData && errorData.moved_to_site;
  if (typeof site !== "string" || !site.startsWith("https://")) return null;
  let target;
  try {
    target = new URL(site);
  } catch {
    return null;
  }
  const loc = location || {};
  if (target.origin === loc.origin) return null;
  const params = new URLSearchParams(loc.search || "");
  if (params.has(MOVED_PARAM)) return null;
  params.set(MOVED_PARAM, "1");
  const base = site.replace(/\/+$/, "");
  return `${base}${loc.pathname || ""}?${params.toString()}${loc.hash || ""}`;
}
